import React, { useState,useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button
} from "@material-ui/core";
import axios from "axios";
import envConfig from "../../../bin/env.config";

import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
 
}));



export default function ButtonSelectCompetitorGroupId({ product, potentialProduct, reloadData, onSelectedSuccess }) {
  const classes = useStyles();
  const history = useHistory();
  const token = useSelector((state) => state.session.token);
  const [serverUpdating, setServerUpdating] = useState(false);
  const handleSelected = ()=>{
    setServerUpdating(true)
  } 
  const handleCreateAndMatch = ()=>{
    // history.push(`/possible-existing/${product.productID}`);
    window.open(`/possible-existing/${potentialProduct.productID}`);
  } 

  useEffect(() => {
    const serverUpdate = async () => {
      try {
        let putData = {
          product_id: product.id,
          pmg_id: potentialProduct.pmg_id
        }; 
        const url = `${envConfig.API_ROOT}${envConfig.API_VERSION}/company-report-tool/select-competitor-group_id`;
        await axios.post(url, putData, {
          headers: {
            Authorization: JSON.stringify(token),
          },
        });
        reloadData && reloadData();
        onSelectedSuccess && onSelectedSuccess();
      } catch (error) {
        console.error("Failed to select competitor group id", error);
      } finally {
        setServerUpdating(false);
      }
    };
    serverUpdating&&serverUpdate();
  }, [serverUpdating, product, potentialProduct, token, reloadData, onSelectedSuccess]);
  return (
    <>
       {potentialProduct.pmg_id>0?(          
            <Button  variant="outlined"  color="primary" onClick={handleSelected}>
              {potentialProduct.pmg_id}
            </Button>
        ):(
          <Button  variant="outlined" color="secondary" onClick={handleCreateAndMatch}>
            Create
          </Button>
        )}
    </>
  );
}
